export enum PercentageIndicatorTypeEnum {
  percentage,
  number,
}
